'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldTooltipClose = exports.isOverlapping = exports.isCursorOver = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _PlacementConstants = require('../PlacementConstants');

var _Placement = require('./Placement');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Detect if a mouseevent occurred within a given rectangle of UI coordinates
 **/
var isCursorOver = exports.isCursorOver = function isCursorOver(boundingClientRect, mouseEvent) {
  var top = boundingClientRect.top,
      bottom = boundingClientRect.bottom,
      left = boundingClientRect.left,
      right = boundingClientRect.right;
  var X = mouseEvent.clientX,
      Y = mouseEvent.clientY;


  return X >= left && X <= right && Y <= bottom && Y >= top;
};

/**
 * Detect if a mouseevent occurred within a given rectangle of UI coordinates
 **/
var isOverlapping = exports.isOverlapping = function isOverlapping(rect1, rect2) {
  return rect1.top < rect2.bottom && rect2.top < rect1.bottom && rect1.left < rect2.right && rect2.left < rect1.right;
};

/**
 * Calculate the dimensions of the gap between tooltip and the trigger element
 *
 * @returns Object {top: Number, bottom: Number, left: Number, right: Number}
 **/
var calculateGapArea = function calculateGapArea(target, tooltip, placement) {
  var _extends2;

  // rectangular coordinates of the max area containing both elements
  var gap = {
    top: Math.min(tooltip.top, target.top),
    bottom: Math.max(tooltip.bottom, target.bottom),
    left: Math.min(tooltip.left, target.left),
    right: Math.max(tooltip.right, target.right)
  };

  var keys = (0, _Placement.isHoriz)(placement) ? _PlacementConstants.PLACEMENTS_HORIZ : _PlacementConstants.PLACEMENTS_VERT;

  // we calculate constraints by top/left, so just reverse for bottom/right
  if (placement.indexOf('right') >= 0 || placement.indexOf('bottom') >= 0) {
    keys = [].concat(_toConsumableArray(keys)).reverse();
  }

  // constrain the max area down to just the space between target and tooltip
  return _extends({}, gap, (_extends2 = {}, _defineProperty(_extends2, keys[0], tooltip[keys[1]]), _defineProperty(_extends2, keys[1], target[keys[0]]), _extends2));
};

/**
 * Determine if a tooltip should close, given the target coords, tooltip coords,
 * placement config of the tooltip, and the originating mouse event
 **/
var shouldTooltipClose = exports.shouldTooltipClose = function shouldTooltipClose(target, tooltip, placement, mouseEvent) {
  return !isCursorOver(target, mouseEvent) && !isCursorOver(tooltip, mouseEvent) && !isCursorOver(calculateGapArea(target, tooltip, placement), mouseEvent);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/tooltip/utils/Hover.js
// module id = 145
// module chunks = 0 1